(function(){
 function init(root){
  if (!root || root.__ds) return; root.__ds = true;
  var track = root.querySelector('[data-ds-mq-track]');
  var dots  = root.querySelector('[data-ds-mq-dots]');
  var prev  = root.querySelector('[data-ds-mq-prev]');
  var next  = root.querySelector('[data-ds-mq-next]');
  var hint  = root.querySelector('[data-ds-mq-hint]');
  if (!track || !dots) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var speed = Math.max(6, parseInt(root.getAttribute('data-ds-speed') || '30', 10));
  var uniqueCards = track.querySelectorAll('.ds-marquee__card').length / 2;
  function cardStep(){
    var c = track.querySelector('.ds-marquee__card');
    if (!c) return track.clientWidth;
    var cs = getComputedStyle(track);
    var gap = parseFloat(cs.columnGap || cs.gap || '0');
    return c.getBoundingClientRect().width + gap;
  }
  function loopLength(){ return track.scrollWidth / 2; }
  function buildDots(){
    dots.innerHTML = '';
    for (var i = 0; i < uniqueCards; i++) {
      var b = document.createElement('button');
      b.className = 'ds-marquee__dot';
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      (function(idx){
        b.addEventListener('click', function(){
          track.scrollTo({ left: idx * cardStep(), behavior: 'smooth' });
          pauseFor(3500);
          virtualLeft = idx * cardStep();
        });
      })(i);
      dots.appendChild(b);
    }
    updateActive();
  }
  function updateActive(){
    var step = cardStep();
    if (!step) return;
    var idx = Math.round(track.scrollLeft / step) % uniqueCards;
    if (idx < 0) idx += uniqueCards;
    Array.prototype.forEach.call(dots.children, function(d, i){ d.classList.toggle('is-active', i === idx); });
  }
  var pauseUntil = 0, lastTs = 0, isDragging = false, virtualLeft = 0;
  function pauseFor(ms){ pauseUntil = performance.now() + ms; }
  function isInView(){
    var r = root.getBoundingClientRect();
    return r.bottom > -200 && r.top < (window.innerHeight + 200);
  }
  function tick(ts){
    if (!lastTs) lastTs = ts;
    var dt = ts - lastTs;
    lastTs = ts;
    if (!reduce && !isDragging && !document.hidden && ts > pauseUntil && isInView()) {
      virtualLeft += (speed * dt) / 1000;
      var loop = loopLength();
      if (loop) {
        while (virtualLeft >= loop) virtualLeft -= loop;
        while (virtualLeft < 0) virtualLeft += loop;
      }
      var target = Math.round(virtualLeft);
      if (target !== Math.round(track.scrollLeft)) track.scrollLeft = target;
    }
    requestAnimationFrame(tick);
  }
  function hideHint(){ if (hint) hint.classList.add('is-hidden'); }
  track.addEventListener('touchstart', function(){ hideHint(); pauseFor(4000); }, { passive: true });
  track.addEventListener('touchend', function(){ pauseFor(2500); virtualLeft = track.scrollLeft; }, { passive: true });
  var hintHidden = false;
  track.addEventListener('scroll', function(){
    if (!hintHidden && track.scrollLeft > 40) { hideHint(); hintHidden = true; }
    requestAnimationFrame(updateActive);
  }, { passive: true });
  if (prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -cardStep(), behavior: 'smooth' }); pauseFor(3500); hideHint(); virtualLeft = track.scrollLeft - cardStep(); });
  if (next) next.addEventListener('click', function(){ track.scrollBy({ left: cardStep(), behavior: 'smooth' }); pauseFor(3500); hideHint(); virtualLeft = track.scrollLeft + cardStep(); });
  var isDown = false, startX = 0, scrollStart = 0, moved = false;
  track.addEventListener('mousedown', function(e){
    if (e.button !== 0) return;
    isDown = true; moved = false; isDragging = true;
    startX = e.pageX; scrollStart = track.scrollLeft;
    track.classList.add('is-dragging'); hideHint();
  });
  window.addEventListener('mouseup', function(){
    if (!isDown) return;
    isDown = false; isDragging = false;
    track.classList.remove('is-dragging');
    pauseFor(2500); virtualLeft = track.scrollLeft;
  });
  window.addEventListener('mousemove', function(e){
    if (!isDown) return;
    var dx = e.pageX - startX;
    if (Math.abs(dx) > 4) moved = true;
    if (moved) { e.preventDefault(); track.scrollLeft = scrollStart - dx; }
  });
  track.addEventListener('click', function(e){ if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  window.addEventListener('resize', buildDots);
  buildDots();
  requestAnimationFrame(tick);
 }
 function all(scope){ (scope || document).querySelectorAll('[data-ds-marquee]').forEach(init); }
 if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', function(){ all(); });
 document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();